export const PROD_WEB_WRAPPER_LINK = 'wrapper.playdeck.io';

export const DEV_TG_BOT_LINK = 'https://t.me/replay_deck_bot';
export const PROD_TG_BOT_LINK = 'https://t.me/playdeckbot';
export const PROD_LITE_TG_BOT_LINK = 'https://t.me/gamesweplay_bot';
export const PROD_EXCLUSIVE_TG_BOT_LINK = 'https://t.me/prizenextday_bot';

const BASE_TG_PATH = '/market';

export const PROD_TG_MARKET_LINK = PROD_TG_BOT_LINK + BASE_TG_PATH;
export const DEV_TG_MARKET_LINK = DEV_TG_BOT_LINK + BASE_TG_PATH;
export const PROD_LITE_TG_MARKET_LINK = PROD_LITE_TG_BOT_LINK + BASE_TG_PATH;
export const PROD_TG_WRAPPER_LINK = `${PROD_TG_BOT_LINK}/game`;
export const DEV_TG_WRAPPER_LINK = `${DEV_TG_BOT_LINK}/wrapper`;

export const PROD_LITE_TG_WRAPPER_LINK = `${PROD_LITE_TG_BOT_LINK}/market`;
export const DESKTOP_PLATFORMS = ['macos', 'tdesktop', 'unknown', 'web'];
